import type { ClinicalSummaryReview } from '@/pages/order/clinicalSummaryReviewTypes'
import type { CategorizedHPOOption } from '@/types/RequisitionFormTypes'

export function phenotypeReviewRows(
  clinicalDiagnosis: CategorizedHPOOption[],
  review?: ClinicalSummaryReview | null,
  labels: Readonly<Record<string, string>> = {}
): CategorizedHPOOption[] {
  const rows = [...clinicalDiagnosis]
  const diagnosisCodes = new Set(rows.map((term) => term.id))
  for (const [code, termReview] of Object.entries(review?.terms ?? {})) {
    if (termReview.reviewState === 'needs-input' && !diagnosisCodes.has(code)) {
      const label = labels[code] ?? code
      rows.push({
        id: code,
        label,
        category: 'Key',
        source: 'phenoml',
        node: { id: code, lbl: label, type: 'PhenotypicFeature' },
      })
    }
  }
  return rows
}
